<div id="modal-content-wrapper"
     [ngStyle]="{'direction': this.apiService.currentDirection === 'rtl'? 'rtl': 'ltr', 'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">
  <header id="modal-header">
    <!--    <h1 id="addEditDel-title">{{ modalData.title|translate }}</h1>-->
  </header>
  <section id="modal-body" >
    <div class=" col-md-12 zoomin text-center" style=" max-height: 37vh;overflow: auto">
      <img [src]="modalData.url" id="viewableImage"/>
    </div>

  </section>
  <footer class="row d-flex justify-content-end px-5">
    <div class="my-2">
      <button class=" imgControlBtn" (click)="zoomIn(1)"><i class="fa fa-search-plus" aria-hidden="true"></i></button>
      <button class=" imgControlBtn" (click)="zoomIn(-1)"><i class="fa fa-search-minus" aria-hidden="true"></i></button>
      <button class=" imgControlBtn" (click)="rotate()"><i class="fa fa-repeat" aria-hidden="true"></i></button>
    </div>

      <input type="input" style="width: 0;height: 0; border: none;outline: none;background: transparent" autofocus/>

      <button class="btn my-2" (click)="closeModal()">
        {{'Button.Close'|translate}}
      </button>


    <!--    <button  class="btn mx-1" (click)="actionFunction()">-->
    <!--      {{ modalData.actionButtonText |translate}}-->
    <!--    </button>-->

  </footer>
</div>


